import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import Euler, { EulerTouchableOpacityProps } from '@euler/components/layout';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode, useCallback } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const OrderTagPill = memo(
  ({
    icon,
    tag,
    onRemove,
    onPress,
    textStyle,
    ...props
  }: {
    icon?: ReactNode;
    tag: string;
    textStyle?: StyleProp<TextStyle>;
    onRemove?: (tag: string) => void;
    onPress?: () => void;
  } & EulerTouchableOpacityProps) => {
    const { rpx } = useResponsiveContext();
    const {
      order: { tagTextColor, tagBgColor = 'transparent', tagBorderColor },
    } = useTheme();

    const onRemovePress = useCallback(() => {
      onRemove?.(tag);
    }, [onRemove, tag]);

    return (
      <Euler.TouchableOpacity
        flexDirection="row"
        backgroundColor={tagBgColor}
        borderColor={tagBorderColor}
        borderWidth={1}
        justifyContent="flex-start"
        alignItems="center"
        height={rpx(28)}
        paddingHorizontal={rpx(10)}
        borderRadius={rpx(14)}
        mb={rpx(5)}
        onPress={onPress}
        activeOpacity={onPress ? undefined : 1}
        {...props}
      >
        {icon}
        <Typography.Label
          size={rpx(14)}
          color={tagTextColor}
          style={textStyle}
          numberOfLines={1}
        >
          {tag}
        </Typography.Label>
        {onRemove && (
          <Euler.TouchableOpacity
            backgroundColor={StatusColors.Danger}
            alignItems="center"
            justifyContent="center"
            width={rpx(16)}
            height={rpx(16)}
            borderRadius={rpx(8)}
            ml={rpx(5)}
            mr={rpx(-4)}
            onPress={onRemovePress}
          >
            <Icon name="close" size={rpx(12)} color={'white'} />
          </Euler.TouchableOpacity>
        )}
      </Euler.TouchableOpacity>
    );
  },
);
